import { Component } from '@angular/core';

import { MenuDisplayMode } from '@frontend/vanilla/core';
import { MenuItemComponent } from '@frontend/vanilla/features/menus';

import { BottomSheetItemBase } from '../bottom-sheet-item-base';

@Component({
    imports: [MenuItemComponent],
    selector: 'vn-bs-button',
    templateUrl: 'button.html',
})
export class ButtonComponent extends BottomSheetItemBase {
    constructor() {
        super();
    }

    protected readonly MenuDisplayMode = MenuDisplayMode;
}
